import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [{
        path: '/',
        redirect: () => {
            return '/login'
        }
    },
    {
        path: '/login',
        component: () =>
            import ('../views/login'),
        meta: {
            title: '北京消防协会会员信息系统-登录',
        }
    },
    {
        path: '/register',
        component: () =>
            import ('../views/register'),
        meta: {
            title: '北京消防协会会员信息系统-注册',
        }
    },
    {
        path: '/mobile/login',
        component: () =>
            import ('../views/mobile/login'),
        meta: {
            title: '北京消防协会会员信息系统-注册',
        }
    },
    {
        path: '/mobile/register',
        component: () =>
            import ('../views/mobile/register'),
        meta: {
            title: '北京消防协会会员信息系统-注册',
        }
    },
    {
        path: '/mobile/info',
        component: () =>
            import ('../views/mobile/info'),
        meta: {
            title: '北京消防协会会员信息系统-完善信息',
        }
    },
    {
        path: '/mobile/admin/member/list',
        component: () =>
            import ('../views/mobile/member/list'),
        meta: {
            title: '北京消防协会会员信息系统',
        }
    },
    {
        path: '/mobile/admin/member/detail',
        component: () =>
            import ('../views/mobile/member/detail'),
        meta: {
            title: '北京消防协会会员信息系统-会员详情',
        }
    },
    {
        path: '/forget',
        component: () =>
            import ('../views/forget'),
        meta: {
            title: '北京消防协会会员信息系统-忘记密码',
        }
    },
    {
        path: '/home',
        component: () =>
            import ('../views/home'),
        children: [{
                path: '',
                redirect: 'index'
            },
            {
                path: 'index',
                meta: {
                    title: '会员首页',
                },
                component: () =>
                    import ('../views/member/index'),
            },
            {
                path: 'payment',
                meta: {
                    title: '在线缴费',
                },
                component: () =>
                    import ('../views/member/payment'),
            },
            {
                path: 'paymentRecord',
                meta: {
                    title: '缴费记录',
                },
                component: () =>
                    import ('../views/member/paymentRecord'),
            },
            {
                path: 'info',
                meta: {
                    title: '入会申请',
                },
                component: () =>
                    import ('../views/member/info'),
            },
            {
                path: 'info2',
                meta: {
                    title: '会员信息',
                },
                component: () =>
                  import ('../views/member/info2'),
            },
            {
                path: 'memberDetail/:id',
                meta: {
                    title: '会员信息详情',
                },
                component: () =>
                    import ('../views/admin/memberDetail'),
            },
            {
                path: 'credit',
                meta: {
                    title: '信用信息情况',
                },
                component: () =>
                  import ('../views/member/credit'),
            },
            {
                path: 'infoup',
                meta: {
                    title: '变更信息',
                },
                component: () =>
                    import ('../views/member/infoup'),
            },
            {
                path: 'certificate',
                meta: {
                    title: '会员证书',
                },
                component: () =>
                    import ('../views/member/certificate'),
            },
            {
                path: 'renew',
                meta: {
                    title: '会员缴费',
                },
                component: () =>
                    import ('../views/member/renew'),
            },
            {
                path: 'notice',
                meta: {
                    title: '通知公告',
                },
                component: () =>
                    import ('../views/member/notice'),
            },
            {
                path: 'noticeDetail/:id',
                meta: {
                    title: '通知公告详情',
                },
                component: () =>
                    import ('../views/member/noticeDetail'),
            },
            {
                path: 'question',
                meta: {
                    title: '常见问题',
                },
                component: () =>
                    import ('../views/member/question'),
            },
            {
                path: 'account',
                meta: {
                    title: '帐号管理',
                },
                component: () =>
                    import ('../views/member/account'),
            },
        ],
    },
    {
        path: '/admin',
        component: () =>
            import ('../views/home'),
        children: [{
                path: '',
                redirect: 'examine'
            },
            {
                path: 'examine',
                meta: {
                    title: '会员审核',
                },
                component: () =>
                    import ('../views/admin/examine'),
            },
            {
                path: 'examineDetail/:id',
                meta: {
                    title: '会员审核详情',
                },
                component: () =>
                    import ('../views/admin/examineDetail'),
            }, {
                path: 'examineEdit/:id',
                meta: {
                    title: '会员审核信息修改',
                },
                component: () =>
                    import ('../views/admin/examineEdit'),
            },
            {
                path: 'member',
                meta: {
                    title: '会员管理',
                },
                component: () =>
                    import ('../views/admin/member'),
            },
            {
                path: 'memberEdit/:id',
                meta: {
                    title: '会员信息编辑',
                },
                component: () =>
                    import ('../views/admin/memberEdit'),
            },
            {
                path: 'memberDetail/:id',
                meta: {
                    title: '会员信息详情',
                },
                component: () =>
                    import ('../views/admin/memberDetail'),
            },
            {
                path: 'memberPayment/:id/:name',
                meta: {
                    title: '缴费信息及发票管理',
                },
                component: () =>
                    import ('../views/admin/memberPayment'),
            },
            {
                path: 'paymentRecord',
                meta: {
                    title: '缴费记录',
                },
                component: () =>
                    import ('../views/admin/paymentRecord'),
            },
            {
                path: 'creditExamineList',
                meta: {
                    title: '信用信息情况审核',
                },
                component: () =>
                    import ('../views/admin/creditExamineList'),
            },
            {
                path: 'creditList',
                meta: {
                    title: '信用信息情况',
                },
                component: () =>
                    import ('../views/admin/creditList'),
            },
            {
                path: 'interactiveLabel',
                meta: {
                    title: '互动标签管理',
                },
                component: () =>
                    import ('../views/admin/interactiveLabel'),
            },
            {
                path: 'credit/:id/:user_id/:type',
                meta: {
                    title: '信用信息情况',
                },
                component: () =>
                    import ('../views/admin/credit'),
            },
            {
                path: 'memberCertificate/:id',
                meta: {
                    title: '会员证书',
                },
                component: () =>
                    import ('../views/admin/memberCertificate'),
            },
            {
                path: 'prepare',
                meta: {
                    title: '预备会员',
                },
                component: () =>
                    import ('../views/admin/prepare'),
            },
            {
                path: 'prepareEdit/:id',
                meta: {
                    title: '预备会员编辑',
                },
                component: () =>
                    import ('../views/admin/prepareEdit'),
            },
            {
                path: 'labels',
                meta: {
                    title: '会员联系',
                },
                component: () =>
                    import ('../views/admin/labels'),
            },
            {
                path: 'notice',
                meta: {
                    title: '通知公告',
                },
                component: () =>
                    import ('../views/admin/notice'),
            },
            {
                path: 'noticeDetail/:id',
                meta: {
                    title: '通知公告详情',
                },
                component: () =>
                    import ('../views/admin/noticeDetail'),
            },

            {
                path: 'noticeEdit/:id',
                meta: {
                    title: '通知公告编辑',
                },
                component: () =>
                    import ('../views/admin/noticeEdit'),
            },
            {
                path: 'noticeFeedback/:id',
                meta: {
                    title: '反馈信息',
                },
                component: () =>
                    import ('../views/admin/noticeFeedback'),
            },
            {
                path: 'noticeCode/:id',
                meta: {
                    title: '二维码',
                },
                component: () =>
                    import ('../views/admin/noticeCode'),
            },
            {
                path: 'noticeSign/:id',
                meta: {
                    title: '报名信息',
                },
                component: () =>
                    import ('../views/admin/noticeSign'),
            },



            {
                path: 'record',
                meta: {
                    title: '发送记录',
                },
                component: () =>
                    import ('../views/admin/record'),
            },
            {
                path: 'recordDetail',
                meta: {
                    title: '发送记录',
                },
                component: () =>
                    import ('../views/admin/recordDetail'),
            },
            {
                path: 'recordSms',
                meta: {
                    title: '短信群发',
                },
                component: () =>
                    import ('../views/admin/recordSms'),
            },
            {
                path: 'statistics',
                meta: {
                    title: '会员统计',
                },
                component: () =>
                    import ('../views/admin/statistics'),
            },
            {
                path: 'question',
                meta: {
                    title: '常见问题',
                },
                component: () =>
                    import ('../views/admin/question'),
            },
            {
                path: 'pass',
                meta: {
                    title: '密码修改',
                },
                component: () =>
                    import ('../views/admin/pass'),
            },

            {
                path: 'account',
                meta: {
                    title: '帐号管理',
                },
                component: () =>
                    import ('../views/admin/account'),
            },
        ],
    },
    {
        path: '/mnotice/:id',
        component: () =>
            import ('../views/mobile/notice.vue'),
        meta: {
            title: '北京消防协会会员信息系统-活动详情',
        }
    },
    {
        path: '/mnoticeSignup/:id',
        component: () =>
            import ('../views/mobile/noticeSignUp.vue'),
        meta: {
            title: '北京消防协会会员信息系统-活动报名',
        }
    },
    {
        path: '/mnoticeSignin/:id',
        component: () =>
            import ('../views/mobile/noticeSignIn.vue'),
        meta: {
            title: '北京消防协会会员信息系统-活动签到',
        }
    },
]

const router = new VueRouter({
    routes,
    base: process.env.BASE_URL,
    mode: 'history',
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

export default router